<script>
import ServidorDadosCadastrais from '@/components/shared/servidor/ServidorDadosCadastrais.vue'

export default {
  extends: ServidorDadosCadastrais,
}
</script>
